// The app's URLs. Deep links survive reload: the API serves index.html for any non-API path.
//   /                                   landing, empty state, or the last workspace's board
//   /w/:ws/board?repo=&show=&q=&col=   a workspace's board (filters and search in the query)
//   /w/:ws/repos/:repo/records/:key?tab=   a record, full page
//   /w/:ws/fleet?tab=                   the fleet: machines (and CI, milestone 2); owners only
//   /w/:ws/settings#hosts               workspace admin (sections by anchor)
//   /style-guide                        tokens, icons and components
export const boardPath = (ws: number, query = ''): string => `/w/${ws}/board${query ? `?${query}` : ''}`;
export const recordPath = (ws: number, repo: number, key: string): string =>
  `/w/${ws}/repos/${repo}/records/${encodeURIComponent(key)}`;
export const settingsPath = (ws: number): string => `/w/${ws}/settings`;
export const fleetPath = (ws: number, tab?: 'machines' | 'ci'): string => `/w/${ws}/fleet${tab && tab !== 'machines' ? `?tab=${tab}` : ''}`;
export const settingsSectionPath = (ws: number, section: string): string => `/w/${ws}/settings#${section}`;
